import { IdentificationCard } from '@idc-forms/types/identifications'
import { z } from 'zod'
import { cuiIsValid, optionalString, requiredString } from '../primitives'
import { MESSAGES } from '../utils/messages'
import { PlaceSchema } from './place'

// Forma REAL (shared/schemas/identification.ts): { type, number, dateDue?, emission?: Place }
// CUI condicional: DPI ('D') y Certificado de nacimiento ('CN') exigen 13 dígitos + checksum.
export const IdentificationCardSchema = z
  .object({
    type: z.nativeEnum(IdentificationCard),
    number: requiredString(),
    dateDue: optionalString(),
    emission: PlaceSchema.optional()
  })
  .superRefine((value, ctx) => {
    const requiresCui =
      value.type === IdentificationCard.DPI || value.type === IdentificationCard.BIRTH_CERTIFICATE
    if (requiresCui && !cuiIsValid(value.number)) {
      ctx.addIssue({
        path: ['number'],
        code: z.ZodIssueCode.custom,
        message: MESSAGES.CUI_INVALID
      })
    }
  })

export type IdentificationCardData = z.infer<typeof IdentificationCardSchema>
